module.exports = __webpack_public_path__ + "img/send-icon.b5b1b39d.svg";